export default [
  {
    path: '/country',
    name: 'country',
    component: () => import('@/views/menu/country.vue'),
    meta: {
      pageTitle: 'مدیریت کشورها',
      action: 'show',
      resource: 'CountryManager',
    },
  },
  {
    path: '/city',
    name: 'city',
    component: () => import('@/views/menu/city.vue'),
    meta: {
      pageTitle: 'مدیریت شهرها',
      action: 'show',
      resource: 'CityManager',
    },
  },
  {
    path: '/airport',
    name: 'airport',
    component: () => import('@/views/menu/airport.vue'),
    meta: {
      pageTitle: 'مدیریت فرودگاه‌ها',
      action: 'show',
      resource: 'AirportManager',
    },
  },
  {
    path: '/airport/details/:id?',
    name: 'airportdetails',
    component: () => import('@/views/menu/airportdetails.vue'),
    meta: {
      pageTitle: 'جزئیات فرودگاه',
      action: 'show',
      resource: 'AirportManager',
    },
  },
  {
    path: '/airline',
    name: 'airline',
    component: () => import('@/views/menu/airline.vue'),
    meta: {
      pageTitle: 'مدیریت ایرلاین‌ها',
      action: 'show',
      resource: 'AirlineManager',
    },
  },
  {
    path: '/airline/details/:id?',
    name: 'airlinedetails',
    component: () => import('@/views/menu/airlinedetails.vue'),
    meta: {
      pageTitle: 'جزئیات ایرلاین',
      action: 'show',
      resource: 'AirlineManager',
    },
  },
  {
    path: '/hotel',
    name: 'hotel',
    component: () => import('@/views/menu/hotel/hotel.vue'),
    meta: {
      pageTitle: 'مدیریت هتل ها',
      action: 'show',
      resource: 'HotelManager',
    },
  },
  {
    path: '/hotel/details/:id?',
    name: 'hoteldetails',
    component: () => import('@/views/menu/hotel/hoteldetails.vue'),
    meta: {
      pageTitle: 'جزئیات هتل',
      action: 'show',
      resource: 'HotelManager',
    },
  },
    {
        path: '/tour',
        name: 'tour',
        component: () => import('@/views/menu/tour/tour.vue'),
        meta: {
            pageTitle: 'مدیریت تورها',
            action: 'show',
            resource: 'TourManager',
        },
    },
    {
        path: '/tour/details/:id?',
        name: 'tourdetails',
        component: () => import('@/views/menu/tour/tourdetails.vue'),
        meta: {
            pageTitle: 'جزئیات تور',
            action: 'show',
            resource: 'TourManager',
        },
    },
  {
    path: '/tourcategory',
    name: 'tourcategory',
    component: () => import('@/views/menu/tour/tourcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی ها',
      action: 'show',
      resource: 'TourCategoryManager',
    },
  },
  {
    path: '/tourcategory/details/:id?',
    name: 'tourcategorydetails',
    component: () => import('@/views/menu/tour/tourcategorydetails.vue'),
    meta: {
      pageTitle: 'جزئیات دسته بندی',
      action: 'show',
      resource: 'TourCategoryManager',
    },
  },
]
